import { z } from 'zod'

import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type PrintAgent,
  PrintAgentSchema,
  type RemotePrintResult,
  RemotePrintResultSchema,
} from './schemas'

// 인쇄 서버는 생성 타입이 없어 입력을 unknown 으로 받는다(근거는 schemas.ts 머리).
export const adaptPrintAgents = (raw: unknown): PrintAgent[] =>
  parseApiResponse(z.array(PrintAgentSchema), raw, 'RemotePrint')

export const adaptRemotePrintResult = (raw: unknown): RemotePrintResult =>
  parseApiResponse(RemotePrintResultSchema, raw, 'RemotePrint')
